import React, { useEffect } from 'react';
import { ScreenNamesEnum } from '@/constants';
import { actionSetConversations } from '@/redux';
import { VisitStatusEnum } from '@matap/shared';
import { useAppDispatch, useAppSelector } from '@/hooks/use.redux';
import { useUser } from '@/hooks/use.user';
import { useActiveVisit } from '@/hooks/use.active.visit';
import { useCallConnection } from '@/hooks/use.call.connection';
import { useAssets } from '@/hooks/use.assets';
import { AppTextView } from '@/components/base/app.text.view';
import { getFileSystem } from '../file-manager';
import { useAppRouter } from '@/hooks/use.app.router';
import { Redirect } from '@/components/compose/reset.to';
import { AppScreen } from '@/components/compose/app.screen';
import { IntroView } from '@/components/compose/intro.view';
import { Box } from '@/components/base/box';
import styled from 'styled-components/native';
import { AppLottieView } from '@/components/base/app.lottie.view';

export function withProtectedRoute(Component: any) {
  return function ProtectedRoute(props: any) {
    const firstLogin = useAppSelector((state) => state.generalReducer.firstLogin);

    const { state } = useAppRouter();
    const { userState, authenticated } = useUser();
    const { activeVisit: visit } = useActiveVisit();
    const dispatch = useAppDispatch();
    const assets = useAssets();
    const { activeCall } = useCallConnection();

    const isInsideChatDomain = !!state.routes.find((r) => r.name === ScreenNamesEnum.ChatScreen);

    const hasStartedVisit = userState && visit?.status === VisitStatusEnum.STARTED;
    const stateLoaded = !!userState;

    useEffect(() => {
      if (!stateLoaded) {
        return;
      }
      if (activeCall && !hasStartedVisit) {
        activeCall.destroy();
      }
      if (!hasStartedVisit) {
        dispatch(actionSetConversations({ chats: [], userId: '' }));
        getFileSystem(false).purge();
      }
    }, [stateLoaded, hasStartedVisit, activeCall, dispatch]);

    if (!authenticated) {
      return <Redirect to={ScreenNamesEnum.SignIn} type={'reset'} />;
    }

    if (firstLogin) {
      return (
        <AppScreen>
          <IntroView />
        </AppScreen>
      );
    }

    if (!userState) {
      return (
        <AppScreen>
          <LoaderBox flex={1} alignItems={'center'} justifyContent={'center'}>
            <LoaderAnimation loop autoPlay source={assets.animations.spinner_big} />
            <AppTextView text={'در حال برقراری ارتباط...'} textColor={'grey_light'} />
          </LoaderBox>
        </AppScreen>
      );
    }

    if (hasStartedVisit && !isInsideChatDomain) {
      return <Redirect to={ScreenNamesEnum.ChatScreen} type={'reset'} />;
    }

    if (!hasStartedVisit && isInsideChatDomain) {
      return <Redirect to={ScreenNamesEnum.MainScreen} type={'reset'} />;
    }
    return <Component {...props} />;
  };
}

const LoaderBox = styled(Box)`
  gap: 20px;
`;

const LoaderAnimation = styled(AppLottieView)`
  width: ${({ theme }) => theme.min(50)}px;
  height: ${({ theme }) => theme.min(50)}px;
  max-width: 300px;
  max-height: 300px;
`;
